import type { CapabilityConfig, ExtendedConstraints } from '../../../types';
import { hasValue } from '../../../utils';
import * as AppletSpec from '../applet/applet';

export type Applet = AppletSpec.Applet;

export const id = 'dashboard-applet';

export enum Events {}
export enum Actions {
  Attach = 'dashboard-applet:attach',
  Detach = 'dashboard-applet:detach',
}

const VALID_CONFIG_KEYS = [...AppletSpec.VALID_CONFIG_KEYS, 'attach'] as const;
export type Config = AppletSpec.Config & {
  type: typeof id;
  attach?: boolean;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  actionPayloadTuple:
    | [Actions.Attach]
    | [Actions.Detach]
    | [Actions.Attach, AppletSpec.AppletPayload]
    | [Actions.Detach, AppletSpec.AppletPayload];
}>;

export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!AppletSpec.isValidConfig(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  const isAttachNotValid =
    hasValue(config, 'attach') && typeof config.attach !== 'boolean';

  if (isAttachNotValid) {
    return false;
  }

  return true;
}
